import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef } from 'react';
import { zoomOnWaypoint, updateWaypoint } from '../../store/inquerySlice';
import RouteWaypointSearch from './RouteWaypointSearch';

const RouteAddress = ({ id, onNeedsEstimationUpdate, ...props }) => {
    const dispatch = useDispatch();

    const ref = useRef();
    const _waypoints = useSelector((state) => state.inquery.waypoints);
    const waypoint = _waypoints.find(w => w.id === id);

    function onSubmit(_ref, place) {
        dispatch(updateWaypoint({
            id,
            formatted_address: place.formatted_address,
            location: {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            },
        }));
        dispatch(zoomOnWaypoint({
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
        }));
        if (onNeedsEstimationUpdate) {
            onNeedsEstimationUpdate();
        } else {
            console.error("onNeedsEstimationUpdate prop missing in RouteAddress");
        }
    }

    useEffect(() => {
        if (ref.current) {
            ref.current.value = waypoint && waypoint.formatted_address ? waypoint.formatted_address : "";
        }
    }, [waypoint]);

    return (
        <RouteWaypointSearch id={id} innerRef={ref} className="address grow" onSubmit={onSubmit} {...props} />
    );
};

export default RouteAddress;